var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Lib
import React from "react";
import { format, parse } from "date-fns";
import { ratingMap } from "../../interfaces/ReviewVenue";
var Summary = /** @class */ (function (_super) {
    __extends(Summary, _super);
    function Summary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.options = ratingMap;
        _this.changeToEdit = function () {
            _this.props.onEdit();
        };
        _this.mergeTaxLevels = function (tax) {
            return _this.concatTaxonomies(__spreadArray([tax.primary], tax.secondary, true));
        };
        _this.concatTaxonomies = function (cats) {
            if (!cats.length)
                return "";
            var labels = cats.map(function (tax) { return tax.label; });
            return labels.join(', ');
        };
        _this.concatStrings = function (values) {
            return __spreadArray([], values, true).join(', ');
        };
        _this.getRatingString = function (ratingValue) {
            var filtered = _this.options.filter(function (option) { return option.value === parseInt(ratingValue); });
            if (!filtered.length)
                return '';
            return filtered[0].label;
        };
        _this.getDateFormatted = function () {
            if (_this.props.values.review.dateOfVisit === null || !_this.props.values.review.dateOfVisit.length)
                return '';
            var date = parse(_this.props.values.review.dateOfVisit || new Date(), 'yyyy-MM-dd', new Date());
            return format(date, "dd.MM.yyyy");
        };
        _this.getHeader = function () {
            return (React.createElement("header", { className: "summary__header" },
                React.createElement("h2", null, "Check the Information below before submitting"),
                React.createElement("button", { type: "button", className: "link-btn", onClick: _this.changeToEdit }, "Edit")));
        };
        return _this;
    }
    return Summary;
}(React.PureComponent));
export default Summary;
